import type { OperationPackageInstanceResponse } from '@/features/operation-instances/api';

/**
 * データタブを出さない packageType
 *
 * 2 系統の理由が混ざっている。
 *   1. ドメイン反映がなく表示すべきデータが無い（`BYODRegistration` 〜 `InHouseItocApproval`）
 *   2. データタブの操作を別画面へ移管した（`DeviceInventory`）
 *
 * `DeviceInventory` は束ね（タグ）単位の確認画面
 * （`/it-operation-core/device-inventory-confirmation`）へ操作を移したため、
 * Instance 単位のデータタブを出さない。`usePackage`（データタブの中身の振り分け）にも
 * `DeviceInventory` の分岐は無く、到達すると `Unknown package type` を throw する。
 * ラベル発行（`DeviceInventoryLabelCreation`）は移管対象ではないのでデータタブを残す。
 */
const PACKAGES_WITHOUT_DATA_TAB = ['BYODRegistration', 'DeviceArrangement', 'DeviceLending', 'DeviceReturn', 'MailAddressCreation', 'LicenseAssignment', 'InHouseItocApproval', 'DeviceInventory'] as const satisfies readonly OperationPackageInstanceResponse['packageType'][];
export function isPackageWithoutDataTab(packageType: OperationPackageInstanceResponse['packageType']): boolean {
  return (PACKAGES_WITHOUT_DATA_TAB as readonly string[]).includes(packageType);
}